define(
({
  "load_error": "Error al cargar",
  "description": "La petición no se ha completado correctamente. Asegúrate de que el pedido se ha guardado y después actualiza esta página."
})
);
